module.exports = __webpack_public_path__ + "img/icon (1).221d7420.png";